import type { NonEmptyArray } from '@soundxyz/utils/const';

export function nonEmptyLast<T>(list: NonEmptyArray<T>): T {
  return list[list.length - 1] ?? list[0];
}

export function isNonEmptyArray<Value>(list: readonly Value[]): list is NonEmptyArray<Value> {
  return list.length !== 0;
}
